import { Head as InertiaHead } from "@inertiajs/react";
import { ReactNode } from "react";

interface CustomHeadProps {
  title?: string;
  description?: string;
  robots?: boolean;
  children?: ReactNode;
}

export default function Head({
  title = "Open Court",
  description,
  robots = false,
  children
}: CustomHeadProps) {
  const robotsContent = robots ? "index,follow" : "noindex,nofollow";

  return (
    <InertiaHead title={title}>
      {title && <meta head-key="og-title" property="og:title" content={title} />}
      {description && <meta head-key="og-description" property="og:description" content={description} />}
      {description && <meta head-key="description" name="description" content={description} />}
      <meta head-key="robots" name="robots" content={robotsContent} />
      {children}
    </InertiaHead>
  );
}
